module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-1600.f856561e.svg";